import { getAugmentedNamespace } from './_commonjsHelpers.js';
import * as index from '../node_modules/date-fns/esm/parseISO/index.js';

var require$$58 = /*@__PURE__*/getAugmentedNamespace(index);

export { require$$58 as default };
